import { makeAutoObservable, runInAction } from 'mobx';
import { roomDebugLogsApi } from '@/services/roomDebugLogsApi';
import type { ExportRoomDebugLogsReply } from '@/types';

interface ApiErrorLike {
  message?: string;
  response?: {
    data?: {
      error?: string;
      errmsg?: string;
      message?: string;
    };
  };
}

function getErrorMessage(error: unknown) {
  if (typeof error === 'object' && error !== null) {
    const apiError = error as ApiErrorLike;
    return (
      apiError.response?.data?.errmsg ||
      apiError.response?.data?.message ||
      apiError.response?.data?.error ||
      apiError.message ||
      '导出日志失败'
    );
  }

  return '导出日志失败';
}

class RoomDebugLogsStore {
  exporting = false;
  lastExport: ExportRoomDebugLogsReply | null = null;
  error = '';

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  clearResult() {
    this.lastExport = null;
    this.error = '';
  }

  async exportLogs(roomId: string, maxSizeBytes?: number) {
    const trimmedRoomId = roomId.trim();
    if (!trimmedRoomId) {
      throw new Error('Room ID 不能为空');
    }

    this.exporting = true;
    this.error = '';

    try {
      const response = await roomDebugLogsApi.exportLogs(trimmedRoomId, {
        max_size_bytes: maxSizeBytes,
      });

      runInAction(() => {
        this.lastExport = response;
        this.exporting = false;
      });

      return response;
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      runInAction(() => {
        this.exporting = false;
        this.error = errorMessage;
      });
      throw new Error(errorMessage);
    }
  }
}

export const roomDebugLogsStore = new RoomDebugLogsStore();
